export default "__VITE_ASSET__Dwny7p12__"